import type { UserModel } from '~/models/user'
import { Form } from '~/shared/api'
import { clearEmptyFields } from '~/shared/utils/helpers'
import { checkedRule, emailRule, phoneRule, requiredRule } from '~/shared/utils/validation'
import type { SubscribeDto, SubscribeInputParams, SubscriptionParams } from '~/types/subscriptions'

export default class SubscriptionVacanciesForm extends Form<SubscribeDto> {
  email: string
  phone: string = ''
  documents: Array<string> = []
  isConsentGiven: boolean = false
  marketingAccepted: boolean = false

  constructor(
    private readonly params: SubscribeInputParams,
    private readonly user: UserModel | null = null
  ) {
    super()
    this.email = user?.email ?? ''
  }

  toDto(): SubscribeDto {
    const { sp, search, region, 'tf:employment_value_kw': employment } = this.params
    const requestData = clearEmptyFields({ search, region, 'tf:employment_value_kw': employment })
    const params: SubscriptionParams = clearEmptyFields({
      sp,
      ...(Object.keys(requestData).length > 0 && { request_data: requestData }),
    })

    return {
      email: this.email,
      phone: this.phone,
      documents: this.documents,
      ...(this.user && { user_id: this.user.id }),
      subscription: { type: 'vacancies', params },
    }
  }

  static rules() {
    return {
      email: { ...requiredRule, ...emailRule },
      phone: { ...requiredRule, ...phoneRule },
      isConsentGiven: checkedRule,
    }
  }
}
